import axios from "@/plugins/axios";

import * as nanuri from "./nanuri";

let url = "/api/v1/partners";

export default {
    ...nanuri,
    getPartners(data){
        return axios.get(url, data).then(result => result.data);
    },
    getPartner(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
}
